<template>
  <div>
  </div>
</template>

<script>
import {logout} from "@/api/login";

export default {
  name: "Logout",
  mounted() {
    logout().then(()=>{
      this.$store.commit("logout")
      this.$router.push('/login')
      location.reload()
    })
  }
}
</script>

<style scoped>

</style>
